<template>
  <div class="key-header column is-12">
    <div class="columns data-row">
      <div
        class="column top-column"
        :class="{ 'is-10': isExpired, 'is-8': isRevoked, 'is-9': isActive }"
      >
        <div class="columns">
          <div class="column is-2">
            Name
          </div>
          <div class="column is-3">
            Id
          </div>
          <div class="column is-3">
            Scope
          </div>
          <div class="column is-2" v-if="isExpired">
            Expired At
          </div>
          <div class="column is-2" v-else>
            Expires At
          </div>
          <div class="column is-2">
            Created At
          </div>
        </div>
      </div>
      <div
        class="column top-column"
        :class="{ 'is-2': isExpired, 'is-4': isRevoked, 'is-3': isActive }"
      >
        <div class="columns">
          <div
            class="column is-5"
            :class="{ 'is-12': isExpired, 'is-6': isRevoked, 'is-8': isActive }"
          >
            Created by
          </div>
          <div class="column is-4" v-if="isActive">
            Action
          </div>
          <div class="column is-6" v-if="isRevoked">
            Revoked By / Revoked At
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { mapState } from 'vuex';

export default {
  name: 'KeyHeader',
  props: {
    currentTab: {
      type: String,
    },
  },
  computed: {
    isActive() {
      return this.currentTab === 'active';
    },
    isRevoked() {
      return this.currentTab === 'revoked';
    },
    isExpired() {
      return this.currentTab === 'expired';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';
</style>
